<template>
    <div>
        <AppHeader/>
        <v-form class="ma-5">
            <v-container>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="8">
                        <div class="video-container">
                            <iframe
                                    class="video"
                                    src="https://www.youtube.com/embed/ynL9UxwFvSg"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                            ></iframe>
                        </div>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                        <div class="backgroundColor1">
                            <v-card-title>Zusätzliche Materialien</v-card-title>
                            <v-card-text>
                              <span>
<!--                                <a href="" target="_blank">Blog:</a> Umsetzung Digitalisierung Vertrieb - Anwendungsbereiche gestalten-->
                              </span>
                                <br/>
                                <span>
                                <a href="./../static/thesenpapier_digitalisierung_vertrieb_zukunft_b2b_Vertrieb.pdf" target="_blank">PDF</a> zur Übersicht und Übertragung in die Praxis
                            </span>
                            </v-card-text>
                        </div>
                    </v-col>
                </v-row>
                <v-row class="mt-5 backgroundColor1">
                    <v-col>
                        <v-card-title>Technische Voraussetzungen schaffen</v-card-title>
                        <v-card-text>
                            Ein starkes Fundament ist für den Erfolg der Umstrukturierung von grundlegender Bedeutung.
                            Daten müssen eine gewisse Qualität haben, damit Sie im Rahmen des Sales 4.0-Prozesses von
                            der Nutzung profitieren können.
                            Entlang der gesamten Customer Journey (von der Generierung über die Kundengewinnung bis zur
                            Nachbearbeitung) können Sales 4.0-Ansätze implementiert werden.
                        </v-card-text>
                        <v-card-actions>
                            <router-link to="/" class="text-decoration-none">
                                <v-btn color="third" class="white--text mt-3">zur Übersicht</v-btn>
                            </router-link>
                        </v-card-actions>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    import AppHeader from "./AppHeader";

    export default {
        components: {
            AppHeader,
        },
        data() {
            return {};
        },
    };
</script>

<style scoped>
    .backgroundColor1 {
        background-color: #f7f7f7;
        height: 100%;
        padding: 1em;
    }

    .video-container {
        position: relative;
        padding-bottom: 56.25%;
        padding-top: 0;
        height: 0;
        overflow: hidden;

    }

    .video-container iframe,
    .video-container object,
    .video-container embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>